// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/vil/uScope-extensions/resize-viewer/toolbar-button/toolbar-button.scss
// module id = 354
// module chunks = 0